/* Orizza — PDP "Recently viewed" (sections/orizza-pdp-recently-viewed.liquid).
   Saves the current product's handle to localStorage (newest first), then
   fetches a card for each previously viewed product through the card-only
   view (/products/<handle>?view=oz-card) and hands the filled rail to the
   shared rail behaviour in orizza-pdp-discover.js (window.OzDiscRail). */
(function () {
  var KEY = 'oz-recently-viewed';
  var MAX_STORED = 20;

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORED))); } catch (e) {}
  }

  function initRecent(root) {
    if (root.dataset.ozRecentInit) return;
    root.dataset.ozRecentInit = 'true';

    var current = root.dataset.productHandle;
    var limit = Number(root.dataset.limit) || 8;
    var base = root.dataset.cardUrl || '/products/';
    var rail = root.querySelector('[data-oz-disc-rail]');

    var stored = read();
    var toShow = stored.filter(function (h) { return h && h !== current; }).slice(0, limit);

    // remember this product for the next page
    if (current) write([current].concat(stored.filter(function (h) { return h !== current; })));

    if (!toShow.length || !rail) return;

    Promise.all(toShow.map(function (handle) {
      return fetch(base + encodeURIComponent(handle) + '?view=oz-card')
        .then(function (res) { return res.ok ? res.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (cards) {
      var html = '';
      var gone = [];
      cards.forEach(function (card, i) {
        // a product that was deleted or unpublished returns no card
        if (card.indexOf('oz-dc') === -1) gone.push(toShow[i]);
        else html += card;
      });
      if (gone.length) write(read().filter(function (h) { return gone.indexOf(h) === -1; }));
      if (!html) return;

      rail.innerHTML = html;
      root.hidden = false;
      var hint = root.parentElement && root.parentElement.querySelector('[data-oz-recent-hint]');
      if (hint) hint.hidden = true;
      if (window.OzDiscRail) window.OzDiscRail.init(root);
    });
  }

  function init() {
    document.querySelectorAll('[data-oz-recent]').forEach(initRecent);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
